module.exports = __webpack_public_path__ + "static/media/ceo_title_zh.c2ae8ca0.png";